import type { FilterConfigItem } from "@shared/components/DynamicFilter/index.vue";
import type { PaginatedQuery } from "@shared/types/list";
import { DEFAULT_PAGE_SIZE } from "@shared/types/list";
import { resolveCombinedSearchForRequest, resolveMultiSelectForRequest } from "@shared/utils/filterQuery";
import { t } from "@shared/utils/i18n";
import { AMAZON_VC_LOGISTICS_COMBINED_SEARCH_OPTIONS, AMAZON_VC_LOGISTICS_PLATFORM_OPTIONS, AMAZON_VC_LOGISTICS_TYPE_OPTIONS } from "./data";

export interface AmazonVcLogisticsChannelQueryParam extends PaginatedQuery {
    /** DynamicFilter UiSelect 统一为数组 */
    platform: (string | number)[];
    vcType: (string | number)[];
    name: string;
}

export const DEFAULT_AMAZON_VC_LOGISTICS_CHANNEL_QUERY: AmazonVcLogisticsChannelQueryParam = {
    platform: [],
    vcType: [],
    name: "",
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
};

/** POST /manage/warehouseVcLogisticsChannel/list 请求体 */
export function toAmazonVcLogisticsChannelListRequestParams(query: AmazonVcLogisticsChannelQueryParam): Record<string, unknown> {
    const body: Record<string, unknown> = {
        page: query.page,
        perPage: query.limit,
        platformCode: resolveMultiSelectForRequest(query.platform as unknown as (string | number)[])?.[0],
        vcType: resolveMultiSelectForRequest(query.vcType as unknown as (string | number)[]),
    };
    const channelName = resolveCombinedSearchForRequest(query.name as unknown as string | string[]);
    if (channelName !== undefined) body.channelName = channelName;

    return body;
}

/** POST /manage/warehouseVcLogisticsChannel/export 请求体 */
export function toAmazonVcLogisticsChannelExportRequestParams(query: AmazonVcLogisticsChannelQueryParam): Record<string, unknown> {
    const params = toAmazonVcLogisticsChannelListRequestParams(query);
    delete params.page;
    delete params.perPage;

    return params;
}

export function buildAmazonVcLogisticsChannelFilterConfig(): FilterConfigItem[] {
    return [
        { type: "UiSelect", key: "platform", label: t("平台"), placeholder: t("平台"), options: AMAZON_VC_LOGISTICS_PLATFORM_OPTIONS, width: 62 },
        { type: "UiSelect", key: "vcType", label: t("VC类型"), placeholder: t("VC类型"), options: AMAZON_VC_LOGISTICS_TYPE_OPTIONS, width: 77 },
        {
            type: "UiCombinedSelect",
            key: "amazon_vc_logistics_search",
            label: t("搜索"),
            options: AMAZON_VC_LOGISTICS_COMBINED_SEARCH_OPTIONS,
            props: { selectValue: "name", placeholder: t("搜索内容") },
        },
    ];
}
